module.exports = __webpack_public_path__ + "static/media/yt-snowboard.ec53b825.mov";